import { render, staticRenderFns } from "./empHeaderMobile.vue?vue&type=template&id=3893bc1b&scoped=true&"
import script from "./empHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./empHeaderMobile.vue?vue&type=script&lang=js&"
import style0 from "./empHeaderMobile.vue?vue&type=style&index=0&id=3893bc1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3893bc1b",
  null
  
)

export default component.exports